import api from "../helpers/interceptor";

// ---------news list ---------
export const getNews = async (payload) =>
  await api.get(
    `/newsArticles/getNewsArticlesList?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );

// -------------Add news ---------------
export const addNews = async (payload) =>
  await api.post(`/newsArticles/createNewNewsArticles`, payload);

//Update status
export const updateStatus = async (payload) =>
  await api.put(`/newsArticles/updateNewsStatus`, payload);

//Edit News
export const editNews = async (payload) =>
  await api.put(`/newsArticles/editNewsArticlesDetails`, payload);

//Get News
export const getDetails = async (newsId) =>
  await api.get(`/newsArticles/getNewsArticlesDetails?news_id=${newsId}`);
